<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p39"><span><a href="#/Contents#rp39">CREAM OF CAULIFLOWER SOUP WITH CHEESE</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>Fat-free half-and-half adds a rich creaminess to the soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>½ cup chopped onion</span></p>
<p class="hang"><span>2 cloves garlic, minced</span></p>
<p class="hang"><span>2 tablespoons flour</span></p>
<p class="hang"><span>3½ cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>12 ounces cauliflower, cut into florets</span></p>
<p class="hang"><span>1 large Idaho potato, peeled, cubed</span></p>
<p class="hang"><span>¼–½ cup fat-free half-and-half or fat-free milk</span></p>
<p class="hang"><span>¾ cup (3 ounces) reduced-fat Cheddar cheese</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>Ground mace or nutmeg, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion and garlic in lightly greased large saucepan until tender, about 10 minutes; stir in flour and cook 1 minute. Add broth, cauliflower, and potato and heat to boiling; reduce heat and simmer, covered, until vegetables are tender, 10 to 15 minutes. Remove about half the vegetables from the soup with a slotted spoon and reserve. Purée remaining soup in food processor or blender until smooth; return to saucepan. Add reserved vegetables, half-and-half, and cheese; cook over low heat, stirring, until cheese is melted, 3 to 4 minutes. Season to taste with salt and white pepper; sprinkle each bowl of soup with mace.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 98</span></p>
<p class="per1"><span>% calories from fat: 22</span></p>
<p class="per1"><span>Protein (g): 5.5</span></p>
<p class="per1"><span>Carbohydrate (g): 13.6</span></p>
<p class="per1"><span>Fat (g): 2.4</span></p>
<p class="per1"><span>Saturated fat (g): 1.1</span></p>
<p class="per1"><span>Cholesterol (mg): 7.6</span></p>
<p class="per1"><span>Sodium (mg): 214</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 1.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.5</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
<p class="normalt"><span><span class="small">VARIATIONS</span></span></p>
<p class="normala" id="p39a"><span><b>Chilled Cauliflower Soup</b> — Make soup as above, omitting Cheddar cheese and mace. Add 1 tablespoon dried dill weed to simmering <a id="page_31"></a>soup; process all the soup in food processor, without reserving any vegetables. Refrigerate until chilled; garnish each bowl of soup with chopped dill or parsley.</span></p>
<p class="normala" id="p39b"><span><b>Fennel Bisque with Walnuts</b> — Make soup as above, substituting 1 large leek, sliced, for the onion, and 2 large fennel bulbs, sliced, for the cauliflower. Complete soup as above, omitting Cheddar cheese. Ladle soup into bowls; sprinkle with 3 ounces crumbled blue cheese, and ¼ cup chopped toasted walnuts.</span></p>
<p class="normala" id="p39c"><span><b>Cream of Turnip Soup</b> — Make soup as above, substituting chopped turnips for the cauliflower and reduced-fat Swiss, Gouda, or Havarti cheese for the Cheddar; add ½ teaspoon dried thyme leaves.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0221.vue?20392e53